export default __webpack_public_path__ + "static/media/grand-treasure.38a88166.webp";